import React from "react";
import {get} from "lodash";

const AccessTextPod = ({ podule }) => {
  const longform = get(podule, 'media.long_form.html');
  return (
    <div dangerouslySetInnerHTML={{ __html: longform }}></div>
  );
};

export default AccessTextPod;
